// Pacotes de créditos para compra via PIX (Tribopay)

export interface TribopayPackage {
  id: string;
  name: string;
  credits: number;
  priceInCents: number; // Preço em centavos (ex: 3790 = R$ 37,90)
  priceDisplay: string; // Preço formatado para exibição (USD)
  originalPrice: string; // Preço original riscado para urgência
  priceBRL: string; // Preço formatado em Reais para PIX
  offerHash: string; // Hash da oferta na Tribopay
  productHash: string; // Hash do produto na Tribopay
  checkoutUrl: string; // URL do checkout direto da Tribopay
  popular?: boolean;
  features: string[];
}

export const TRIBOPAY_PACKAGES: Record<string, TribopayPackage> = {
  BASIC: {
    id: "pack_basic",
    name: "Basic",
    credits: 100,
    priceInCents: 3790,
    priceDisplay: "7,90",
    originalPrice: "15,90",
    priceBRL: "37,90",
    offerHash: "rd84aqozoi",
    productHash: "ywzq7ywmcb",
    checkoutUrl: "https://global.tribopay.com.br/rd84aqozoi?",
    popular: false,
    features: ["NSFW Image Generation", "NSFW Video Generation with Audio and Speech", "4K 60fps Video Upscale"],
  },
  PRO: {
    id: "pack_pro",
    name: "Pro",
    credits: 210,
    priceInCents: 7490,
    priceDisplay: "14.90",
    originalPrice: "29,90",
    priceBRL: "74,90",
    offerHash: "ew1ifq5pau",
    productHash: "i6ueota2bl",
    checkoutUrl: "https://global.tribopay.com.br/ew1ifq5pau?",
    popular: false,
    features: ["NSFW Image Generation", "NSFW Video Generation with Audio and Speech", "4K 60fps Video Upscale"],
  },
  SUPREME: {
    id: "pack_supreme",
    name: "Supreme",
    credits: 560,
    priceInCents: 18990,
    priceDisplay: "34.99",
    originalPrice: "89,90",
    priceBRL: "189,90",
    offerHash: "qmazccfu2x",
    productHash: "uypwupf8jx",
    checkoutUrl: "https://global.tribopay.com.br/qmazccfu2x?",
    popular: true,
    features: [
      "NSFW Image Generation",
      "NSFW Video Generation with Audio and Speech",
      "4K 60fps Video Upscale",
      "Faster generation speeds",
      "Priority support",
    ],
  },
};

// Helper para obter pacote pelo ID
export function getTribopayPackage(packageId: string): TribopayPackage | undefined {
  return Object.values(TRIBOPAY_PACKAGES).find((pkg) => pkg.id === packageId);
}

// Helper para validar se todos os hashes foram configurados
export function validateTribopayHashes(): { valid: boolean; missing: string[] } {
  const missing: string[] = [];

  Object.entries(TRIBOPAY_PACKAGES).forEach(([key, pkg]) => {
    if (!pkg.offerHash || pkg.offerHash.trim() === "") {
      missing.push(key);
    }
  });

  return {
    valid: missing.length === 0,
    missing,
  };
}

// Lista de todos os pacotes (útil para renderizar)
export const ALL_PACKAGES = Object.values(TRIBOPAY_PACKAGES);
